import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import parser from 'html-react-parser';

import DocsLayout from '../../layouts/DocsLayout';

// eslint-disable-next-line react/prefer-stateless-function
const DocArticle = ({
  data: { article },
  pageContext: { nodeType },
  location,
}) => (
  <DocsLayout article={article} nodeType={nodeType} location={location}>
    {parser(article.html)}
  </DocsLayout>
);

DocArticle.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default DocArticle;

export const pageQuery = graphql`
  query DocsArticleSingle($fileAbsolutePath: String!) {
    article: markdownRemark(fileAbsolutePath: { eq: $fileAbsolutePath }) {
      ...DocsArticlesSingleFragment
    }
  }
`;
